export default [
    {
        id: 0,
        bde_code: '  ',
        name_ca: 'No aplicable (planta sense tipologia especial)',
        name_en: 'Not applicable (normal floor)',
        name_es: 'No aplicable (planta sin tipología especial)'
    },
    {
        id: 1,
        bde_code: 'SM',
        name_ca: 'Semisoterrani',
        name_en: 'Offer data',
        name_es: 'Semisótano'
    },
    {
        id: 2,
        bde_code: 'EN',
        name_ca: 'Entresòl',
        name_en: 'Mezzanine',
        name_es: 'Entresuelo'
    },
    {
        id: 3,
        bde_code: 'AT',
        name_ca: 'Àtic',
        name_en: 'Attic',
        name_es: 'Ático'
    },
    {
        id: 4,
        bde_code: 'OT',
        name_ca: 'Altres tipologies',
        name_en: 'Other tipologies',
        name_es: 'Otras tipologías'
    }
]





// WEBPACK FOOTER //
// ./src/options/floor_types.js